module.exports = __webpack_public_path__ + "img/dropdownright.c158662b.svg";